.button {
  align-items: center;
  background-color: var(--buttonSecondaryBackground);
  border-radius: 10px;
  color: var(--buttonSecondaryText);
  border: 1px solid #ccc;
  cursor: pointer;
  display: flex;
  font-size: 16px;
  font-weight: bold;
  justify-content: center;
  padding: 8px 12px;
  text-align: center;
  user-select: none;
}
.button:hover {
  background-color: var(--buttonSecondaryHover);
}
.button > span {
  user-select: none;
}
.button.primary {
  background-color: var(--buttonPrimaryBackground);
  color: var(--buttonPrimaryText);
  border: var(--buttonPrimaryBackground);
}
.button.primary:hover {
  background-color: var(--buttonPrimaryHover);
}
.button.danger {
  color: var(--buttonDangerText);
  background-color: var(--buttonDangerBackground);
  border: var(--buttonPrimaryBackground);
}
.button.danger:hover {
  background-color: var(--buttonDangerHover);
}
.button.borderless {
  background-color: transparent;
  border: none;
}
.button.active {
  background-color: var(--navBarButtonActive);
}
.button:disabled {
  background-color: var(--buttonDisabledBackground);
  color: var(--buttonDisabledText);
  cursor: not-allowed;
}
.button:disabled:hover {
  background-color: var(--buttonDisabledBackground);
}